export const initialValues: { [key: string]: { [key: string]: any } } = {
  item: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  stateGrant: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  otherFunds: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  totalFunds: {
    value: 0,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: false,
    },
  },
};

export const itemsTypes = [
  'Construction Cost (Including Fixed Equipment)',
  'Equipment and Furnishing Not Fixed',
  'Architect/Engineer Fees',
  'Land',
];
